import { HttpClient, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable ,  Subject ,  BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { Customer } from '../../../core/interfaces/customers';
import { IExpedientDetails } from '../../../dms/modulos/vc-vo/componentes/recepcion-vo/interfaces/expedient-details.interface';

@Injectable()
export class AdjuntarDocumentosService {
    public actualCustomerCode = new BehaviorSubject<string>('');
    $mediaFileList = new Subject<any>();
    constructor(private _http: HttpClient) { }
    uploadFile(file: File, expedient: Customer): Observable<any> {
        let formData = new FormData();

        formData.append('Filedata', file, file.name);
        formData.append('storeMode', "database");
        formData.append('clientCode', expedient.ClientCode);
        formData.append('companyCode', expedient.CompanyCode);
        formData.append('nombreArchivo', file.name);
        formData.append('FileName', file.name);
        formData.append('Upload', "Submit Query");

        let params = new HttpParams();
        const _URL_ = `${environment.ENTORNO}${environment.SessionService.ENDPOINT.FileUpload}`;
        const options = {
            params: params,
            reportProgress: true
        };

        const req = new HttpRequest('POST', _URL_, formData, options);
        return this._http.request(req);
    }


    getByCustomerCodeWithContacts(params: object) {
        return this._http.post(`${environment.ENTORNO}Services/General/CustomerService.svc/GetByCustomerCodeWithContacts`, params)
            .pipe(map((data) => data["Response"]));
    }
    updateCustomer(params: object) {
        return this._http.post(`${environment.ENTORNO}Services/General/CustomerService.svc/AddMediaFile`, params)
            .pipe(map((data) => data["Response"]));
    }
    deleteFile(params: object) {
        return this._http.post(`${environment.ENTORNO}Services/General/CustomerService.svc/DeleteMediaFile`, params)
            .pipe(map((data) => data["Response"]));
    }
    getMediaFileList(): Observable<any> {
        return this.$mediaFileList.asObservable();
    }
    setMediaFileList(b: any) {
        this.$mediaFileList.next(b)
    }

    observerActualCustomerCode() {
        return this.actualCustomerCode.asObservable();
    }
    setCustomer(value) {
        this.actualCustomerCode.next(value);
    }


}
